import { ButtonHTMLAttributes } from "react"

const ApproveButton = (props: ButtonHTMLAttributes<HTMLButtonElement>) => {
  return <button className="approve-button" type="button"  {...props}/> 
}

export default ApproveButton